import React from 'react';
import {Button} from 'reactstrap';
import PropTypes from 'prop-types';
import Translate from "../../shared/language/Translate";
import GeneralUtils from "../../shared/utils/GeneralUtils";
import DataTableWithButton from "../../shared/component/dataTable/DataTableWithButton";
import OrderItemsColumn from "../../shared/component/dataTable/columns/OrderItemsColumn.json";
import OrderService from "../../shared/service/OrderService";
import {TabPanel, TabView} from "primereact/tabview";
import MerchantUserService from "../../shared/service/MerchantUserService";
import ModalConfirm from "../../shared/component/dialog/ModalConfirm";
import FormSection from "../../shared/component/form/FormSection";
import {OrderDetailTabFields, OrderMoreTabFields} from "./OrderDetailFields";
import '../../shared/styles/SettingsPage.css';
const defaultOrder = {
    id: null,
    orderNo: null,
    orderDate: null,
    basketStatus: null,
    syncStatus: null,
    orderStatus: null,
    acceptedDate: null,
    preparingDate: null,
    readyDate: null,
    deliveredDate: null,
    totalPrice: null,
    orderType: null,
    basketDetailList: []
};
export default class OrderHistoryDetail extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            order: defaultOrder,
            pageMode: null
        }
        this.orderService = new OrderService();
        this.merchantUserService = new MerchantUserService();
    }

    componentDidMount() {
        this.merchantUserService.getDrivers().then(response => this.setState({
            driverList: response
        }));
    }


    render() {
        return (
            <div className="settings-page settings-page--dialog settings-page--order-detail">
                <ModalConfirm header='Warning' ok='OK' onOkClick={this.refund}
                              onCancelClick={() => this.setState({displayShowStatusConfirmDialog: false})}
                              show={this.state.displayShowStatusConfirmDialog}
                              message={this.state.noticeResponse}/>
                <div className="settings-page--order-detail__body">
                <TabView className="settings-page__tabs">

                    <TabPanel header="Order Detail" >
                        <div className="settings-page__tab-panel">
                        <FormSection>
                            <OrderDetailTabFields
                                order={this.state.order}
                                showBasketType={true}
                                variant="history"
                                driverList={this.state.driverList}
                                onDriverChange={this.__handleChange}
                            />
                        </FormSection>
                        </div>
                    </TabPanel>
                    <TabPanel header="More">
                        <div className="settings-page__tab-panel">
                        <FormSection>
                            <OrderMoreTabFields order={this.state.order}/>
                        </FormSection>
                        </div>
                    </TabPanel>
                </TabView>

                <FormSection>
                    <div className="settings-page__table-wrap settings-page__table-wrap--order-items">
                        <DataTableWithButton data={this.state.order.basketDetailList}
                                             className="order-detail-items-table"
                                             ref={(elem) => this.refDataTable = elem}
                                             selectionMode='single'
                                             paginator={false}
                                             fields={OrderItemsColumn.fields}/>
                    </div>
                </FormSection>                </div>

                <div className="settings-page__order-detail-actions">
                    <Button color="outline-primary" className="settings-page__btn--action settings-page__btn--wrap"
                            onClick={() => {
                                this.printReceipt();
                            }}>
                        <Translate contentKey="entity.action.add">Print Receipt</Translate>
                    </Button>

                    {GeneralUtils.isClerk() && this.state.order.basketType == "sale" && this.state.order.clientAgent == "WEB" && this.state.order.basketStatus == "PAID" && this.state.order.orderStatus == "ORDER_CLOSED" &&
                        <Button color="outline-danger" className="settings-page__btn--delete settings-page__btn--wrap"
                                onClick={() => {
                                    this.showChangeStatusConfirmDialog(true)
                                }}>
                            <Translate contentKey="entity.action.add">Refund</Translate>
                        </Button>}

                    <Button color="outline-primary" className="settings-page__btn--cancel settings-page__btn--close"
                            onClick={() => {
                                this.props.closeDisplayDialog();
                            }}>
                        <Translate contentKey="entity.action.cancel">Close</Translate>
                    </Button>
                </div>
            </div>
        );
    }


    showChangeStatusConfirmDialog = (value) => {
        this.setState({
            displayShowStatusConfirmDialog: true,
            noticeResponse: "Are you sure to refund?"
        });
    }
    setData = (data) => {
        this.setState({order: data});
    }

    clearData = () => {
        let obj = Object.assign({}, defaultOrder);
        this.setState({order: obj});
    }

    refund = () => {
        this.setState({loading: true});
        if (!GeneralUtils.isNullOrEmpty(this.state.order.id)) {
            this.orderService.refund(this.state.order.id).then((response) => {
                if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                    this.props.closeDisplayDialog();
                }
                this.setState({loading: false,displayShowStatusConfirmDialog:false});
            });
        }

    }

    printReceipt = () => {
        this.setState({loading: true});
        if (!GeneralUtils.isNullOrEmpty(this.state.order.id)) {
            this.orderService.printReceipt(this.state.order.id).then((response) => {
                if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                    this.props.closeDisplayDialog();
                }
                this.setState({loading: false});
            });
        }

    }


    __handleChange = (e) => {
        let value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
        let order = this.state.order;
        order[e.target.name] = value;
        this.setState({order: order});
    }

}

OrderHistoryDetail.propTypes = {
    order: PropTypes.object
};
